import { Modal } from '@cb/apricot-react';
import { FC } from 'react';

import Typography from './Typography';

interface WhatIsSchoolCodeModalProps {
  trigger?: string;
}

const WhatIsSchoolCodeModal: FC<WhatIsSchoolCodeModalProps> = ({ trigger = 'whatIsSchoolCodeModal' }) => {
  return (
    // @ts-ignore
    <Modal title="What is a School Code?" trigger={trigger} withHeader withFooter>
      <div className="display-flex flex-column cb-align-left" >
        <Typography variant="body1">
          This form is used to request a School Code for schools that do not currently have one.
        </Typography>
        <Typography variant="body1">
          The School Code allows a K-12 School to either receive test scores and/or administer tests.
        </Typography>
        <Typography variant="body1">• Level 1 School Codes allow an organization to receive score reports.</Typography>
        <Typography variant="body1">
          • Level 2 School Codes allow an organization to receive score reports as well as administer tests.
        </Typography>
        <Typography variant="body1">
          Schools need to go through a more rigorous code assignment process to be granted Level 2.
        </Typography>
      </div>
    </Modal>
  );
};

export default WhatIsSchoolCodeModal;
